module.exports = __webpack_public_path__ + "img/assessment_pic@2x.54fac427.png";